import Image from "next/image";
import Link from "next/link";
import ArrowLink from "../ArrowLink";
import Tags from "../Tags";
import style from "./ArticleCard.module.css";
import ArticleCardProps from "./types";
const ArticleCard: React.FC<ArticleCardProps> = ({
  title,
  content,
  image,
  slug,
  tags,
}) => {
  return (
    <div className={style.articleCard}>
      <header>
        <div className={style.imageContainer}>
          {image && (
            <Link href={`/discover/${slug}`} className={style.imageLink}>
              <Image
                src={`/articles/${image}`}
                alt={title}
                width={533 * 2}
                height={618 * 2}
              />
            </Link>
          )}
        </div>
        <h3 className={style.title}>{title}</h3>
        <p className={style.content}>{content}</p>
      </header>
      <footer className={style.footer}>
        <Tags tags={tags} />
        <ArrowLink href={`/discover/${slug}`} label="Read more" fullwidth />
      </footer>
    </div>
  );
};
export default ArticleCard;
